import { z } from "zod";

export enum GitProviderNames {
  Azure = "azure",
  Github = "github",
  Gitlab = "gitlab",
  Bitbucket = "bitbucket",
}

export const GitProvider = z.nativeEnum(GitProviderNames);
export type GitProvider = z.infer<typeof GitProvider>;
